import styled from 'styled-components'

export const StyledDiv = styled.div`
  padding: 15px;
  margin-left: 10px;
`
export const StyledHead = styled.h4`
  font-weight: 600;
`